/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { StorageService } from '../storage.service';
import { ScheduledRechageInterface } from 'src/app/interfaces/api/scheduled-rechage';
import { CryptoService } from '../crypto.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Servicio para dar de alta un biller a un cliente sea regalli o legacy
 */
export class ScheduledRechageService {
  /**
   * Representa el constructor de la clase.
   * Se obtienen referencias a los servicios que se utilizan en diferentes funciones
   * de la clase.
   * Se setean valores por default.
   * @param http
   * @param storageService
   */
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private cryptoService: CryptoService,
  ) {}
  /**
   * Envia los datos al storage para guardar la informacion
   * @param data
   */
  create(_data: ScheduledRechageInterface): Observable<any> {
    const url = this.storageService.get("HOST") + this.storageService.get("SOURCE");
    const location = JSON.parse(this.storageService.get("objGeo"));
    const ke = this.storageService.get("ke");
    const key = ke.substr(-16);
    const iv = ke.substr(0, 16);

    const isTransmit = localStorage.getItem("isTransmit");
    const traceId = this.storageService.get("traceId");

    let headers = {};
    if (isTransmit?.toString() === "true") {
      const token = localStorage.getItem("token2fa");
      const codeVerifier = localStorage.getItem("codeVerifier");
      headers = {
        "x-authentication-Method": "jwt",
        "x-authentication-Value": `${codeVerifier}|${token.replace(/"/g, "")}`,
        "x-spanId": traceId?.toString(),
        "x-traceId": traceId?.toString(),
      };
    }

    return from(this.cryptoService.Encriptar(JSON.stringify(_data), key, iv)).pipe(
      switchMap(requestBodyCrypt => {
        const data = {
          geolocalizacionTaePrimaryRequestTO: location,
          requestBodyCrypt,
        };
        return this.http.post(url + '/billtae/scheduled/createtae', data, { headers });
      })
    );
  }
}